// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-policy',
  title: 'Define and review AI policy',
  description:
    'Confirm that a topic-specific AI policy is defined, approved by management, communicated and reviewed at planned intervals (ISO/IEC 42001 Cl. 5.2 and Annex A.2.2–A.2.4). The policy shall state the principles for responsible AI (fairness, transparency, accountability, human oversight, safety), align with other organisational policies, and set AI management objectives. Review the AI policy document, the approval record and the last policy-review record.',
  category: 'governance',
  scfIds: ['SCF-AIG-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI policy is published' },
    { type: 'document-approved', description: 'AI policy has been approved by management' },
    { type: 'document-within-sla', description: 'AI policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
